// extracted by mini-css-extract-plugin
module.exports = {"container":"SurveySocial_container__3wHkx","socialNetworks":"SurveySocial_socialNetworks__3iWpC","hamidantez":"SurveySocial_hamidantez__2nDbw"};